import { useState, type ReactNode } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { translateServerSideProps } from 'shared/utils/translate-server-side-props'
import ResubscribedCard from 'modules/unsubscribe-page/components/resubscribed-card'
import UnsubscribeCard from 'modules/unsubscribe-page/components/unsubscribed-card'
import { getUnsubscribePageLayout } from 'modules/unsubscribe-page/layouts/get-unsubscribe-page-layout'

function Unsubscribe(): ReactNode {
  const { t } = useTranslation()
  const [isSuccess, setIsSuccess] = useState(false)

  function confirmUnsubscribe(): void {
    setIsSuccess(true)
  }

  return (
    <div className="flex flex-col items-center justify-center">
      {isSuccess ? (
        <ResubscribedCard
          title={t('mailing.unsubscribe_page.unsubscribed_success.title')}
          subTitle={t('mailing.unsubscribed_page.unsubscribed.marketing_emails.text')}
        />
      ) : (
        <UnsubscribeCard isSuccess={true} onConfirmUnsubscribe={confirmUnsubscribe}>
          <div className={'mb-8'}>
            <span> {t('unsubscribe_page.unsubscribe.from_all_marketing_emails')}</span>
          </div>
        </UnsubscribeCard>
      )}
    </div>
  )
}

export const getServerSideProps = translateServerSideProps

Unsubscribe.getLayout = getUnsubscribePageLayout

export default Unsubscribe
